import { on } from "@ngrx/store";
import { AuthenticationActions } from "./authentication.actions";
import { ApplicationStore } from "../application.state";
import { initialAuthenticationState } from "./authentication.state";

// **************************************************************************
// AUTHENTICATION REDUCER (array format for spreading in parent)
// **************************************************************************

const initializeAuthentication = on(AuthenticationActions.initializeAuthentication, (state: ApplicationStore) => ({
    ...state,
    authentication: {
        ...initialAuthenticationState,
        loading: true,
    },
}));

const initializeAuthenticationSuccess = on(AuthenticationActions.initializeAuthenticationSuccess, (state: ApplicationStore, { isAuthenticated }) => ({
    ...state,
    authentication: {
        ...state.authentication,
        isAuthenticated,
        loading: false,
    },
}));

const initializeAuthenticationFailure = on(AuthenticationActions.initializeAuthenticationFailure, (state: ApplicationStore, { error, isAuthenticated }) => ({
    ...state,
    authentication: {
        ...state.authentication,
        isAuthenticated,
        error,
        loading: false,
    },
}));

export const authenticationReducer = [
    initializeAuthentication,
    initializeAuthenticationSuccess,
    initializeAuthenticationFailure,
];
